module.exports = __webpack_public_path__ + "static/media/spotST.9b89efd7.png";